import { twSort } from 'atp-react-ui';

const useStyles = () => ({
  stepIcon: twSort`mb-2.5 mt-5 w-[75px] lg:mb-0 lg:h-[85px] lg:w-[85px]`,
  mainStep: twSort`mb-10 mt-2.5 font-bold text-secondary-dark lg:text-lg lg:leading-7 lg:tracking-wider xl:text-4xl`,
});

export default useStyles;
